/* Forge theme JS — no dependencies. */

(() => {
  const money = (cents) => {
    if (window.Forge && window.Forge.moneyFormat) {
      return window.Forge.moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, (Number(cents) / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }));
    }
    return (Number(cents) / 100).toFixed(2);
  };

  /* ---------- Cart ---------- */

  const Cart = {
    async refreshDrawer(open = false) {
      const drawer = document.getElementById('CartDrawer');
      try {
        const res = await fetch(`${window.Forge.rootUrl}?sections=cart-drawer`);
        const data = await res.json();
        if (drawer && data['cart-drawer']) {
          const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          const fresh = html.getElementById('CartDrawer');
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
      } catch (e) { /* noop */ }
      const cart = await (await fetch(`${window.Forge.rootUrl}cart.js`)).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.toggleAttribute('hidden', cart.item_count === 0);
      });
      if (open) Cart.open();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    },
    open() {
      const drawer = document.getElementById('CartDrawer');
      if (drawer && typeof drawer.showModal === 'function' && !drawer.open) drawer.showModal();
    },
    async add(formData, button) {
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
      }
      try {
        const res = await fetch(`${window.Forge.rootUrl}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const data = await res.json();
        if (!res.ok) {
          Cart.notifyError(data.description || data.message || 'Error');
          return;
        }
        if (window.Forge.cartType === 'drawer') {
          await Cart.refreshDrawer(true);
        } else {
          window.location.href = `${window.Forge.rootUrl}cart`;
        }
      } finally {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('is-loading');
        }
      }
    },
    async change(key, quantity) {
      await fetch(`${window.Forge.rootUrl}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      await Cart.refreshDrawer(false);
      const main = document.getElementById('MainCartItems');
      if (main) window.location.reload();
    },
    notifyError(message) {
      const el = document.getElementById('CartErrors');
      if (el) {
        el.textContent = message;
        el.removeAttribute('hidden');
        setTimeout(() => el.setAttribute('hidden', ''), 5000);
      } else {
        alert(message);
      }
    },
  };
  window.ForgeCart = Cart;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();
    Cart.add(new FormData(form), form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && window.Forge.cartType === 'drawer') {
      event.preventDefault();
      Cart.open();
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      Cart.change(remove.dataset.cartRemove, 0);
    }
    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
    }
    const mapBtn = event.target.closest('[data-load-map]');
    if (mapBtn) {
      const iframe = document.createElement('iframe');
      iframe.src = mapBtn.dataset.mapSrc;
      iframe.className = mapBtn.dataset.mapClass || '';
      iframe.title = mapBtn.dataset.mapTitle || '';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      mapBtn.replaceWith(iframe);
    }
    const dialogOpen = event.target.closest('[data-dialog-open]');
    if (dialogOpen) {
      event.preventDefault();
      const dialog = document.getElementById(dialogOpen.dataset.dialogOpen);
      if (dialog) dialog.showModal();
    }
  });

  document.addEventListener('change', (event) => {
    const qty = event.target.closest('[data-cart-qty]');
    if (qty) Cart.change(qty.dataset.cartQty, parseInt(qty.value, 10) || 0);
    const facets = event.target.closest('form[data-auto-submit]');
    if (facets) facets.submit();
    const localeSelect = event.target.closest('select[data-submit-on-change]');
    if (localeSelect && localeSelect.form) localeSelect.form.submit();
  });

  /* Close dialogs when clicking the backdrop */
  document.addEventListener('mousedown', (event) => {
    const dialog = event.target.closest('dialog[open]');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }
  });

  /* ---------- Quantity input ---------- */

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('button');
        if (!btn || !this.input) return;
        e.preventDefault();
        const step = btn.dataset.action === 'increase' ? 1 : -1;
        const min = parseInt(this.input.min, 10) || 0;
        const next = Math.max(min, (parseInt(this.input.value, 10) || 0) + step);
        this.input.value = next;
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
  customElements.define('quantity-input', QuantityInput);

  /* ---------- Scroll carousel ---------- */

  class ScrollCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.carousel__track');
      this.prevBtn = this.querySelector('[data-carousel-prev]');
      this.nextBtn = this.querySelector('[data-carousel-next]');
      if (!this.track) return;
      const dir = document.documentElement.dir === 'rtl' ? -1 : 1;
      const page = () => this.track.clientWidth * 0.9;
      this.prevBtn?.addEventListener('click', () => this.track.scrollBy({ left: -page() * dir, behavior: 'smooth' }));
      this.nextBtn?.addEventListener('click', () => this.track.scrollBy({ left: page() * dir, behavior: 'smooth' }));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      this.updateButtons();
    }
    updateButtons() {
      if (!this.prevBtn || !this.nextBtn) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      const pos = Math.abs(this.track.scrollLeft);
      this.prevBtn.toggleAttribute('disabled', pos <= 2);
      this.nextBtn.toggleAttribute('disabled', pos >= max);
    }
  }
  customElements.define('scroll-carousel', ScrollCarousel);

  /* ---------- Variant picker ---------- */

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('script[type="application/json"]');
      if (!json) return;
      this.variants = JSON.parse(json.textContent);
      this.addEventListener('change', () => this.onChange());
    }
    selectedOptions() {
      return Array.from(this.querySelectorAll('select, input[type="radio"]:checked')).map((el) => el.value);
    }
    onChange() {
      const options = this.selectedOptions();
      const variant = this.variants.find((v) => v.options.every((opt, i) => opt === options[i]));
      const section = this.closest('[data-product-section]') || document;
      const idInput = section.querySelector('form[data-ajax-cart] input[name="id"], form[action*="/cart/add"] input[name="id"]');
      const button = section.querySelector('[data-add-button]');
      const buttonText = section.querySelector('[data-add-button-text]');
      const priceEl = section.querySelector('[data-price]');
      if (!variant) {
        if (button) button.setAttribute('disabled', '');
        if (buttonText) buttonText.textContent = window.Forge.strings.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        let html = `<span class="price__current">${money(variant.price)}</span>`;
        if (variant.compare_at_price > variant.price) {
          html += ` <s class="price__compare">${money(variant.compare_at_price)}</s>`;
          priceEl.classList.add('price--sale');
        } else {
          priceEl.classList.remove('price--sale');
        }
        priceEl.innerHTML = html;
      }
      if (button && buttonText) {
        if (variant.available) {
          button.removeAttribute('disabled');
          buttonText.textContent = window.Forge.strings.addToCart;
        } else {
          button.setAttribute('disabled', '');
          buttonText.textContent = window.Forge.strings.soldOut;
        }
      }
      if (variant.featured_media_id) {
        const thumb = section.querySelector(`[data-media-thumb][data-media-id="${variant.featured_media_id}"]`);
        if (thumb) thumb.click();
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }
  customElements.define('variant-picker', VariantPicker);

  /* ---------- Product gallery ---------- */

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.main = this.querySelector('[data-gallery-main]');
      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('[data-media-thumb]');
        if (!thumb) return;
        e.preventDefault();
        const target = this.querySelector(`[data-media-item][data-media-id="${thumb.dataset.mediaId}"]`);
        if (target && this.main) {
          this.main.scrollTo({ left: target.offsetLeft - this.main.offsetLeft, behavior: 'smooth' });
        }
        this.querySelectorAll('[data-media-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    }
  }
  customElements.define('product-gallery', ProductGallery);

  /* ---------- Sticky header ---------- */

  const header = document.querySelector('.site-header--sticky');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 10);
      last = y;
    }, { passive: true });
  }
})();
